<div class="toasts-container">
  <ngb-toast *ngFor="let toast of notificationService.toasts" [class]="toast.classname ? toast.classname : ''"
    [autohide]="true" [delay]="toast.delay || DEFAULT_DELAY" (hide)="notificationService.remove(toast)">
    <div class="toast-content">
      <div
        [ngStyle]="{'justify-content': toast.classname === 'bg-success text-light' ? 'flex-start' : 'space-between' }">
        <i *ngIf="toast.iconclass" [ngClass]="toast.iconclass"></i>
        <span translate [innerHTML]="toast.message | translate"></span>
        <button *ngIf="toast.classname !== 'bg-success text-light'" class="vox-btn vox-btn-primary_dark-grey"
          (click)="onCopy(toast.message)" translate [ngbTooltip]="'common.copied' | translate" #t="ngbTooltip"
          [autoClose]="false" triggers="manual">
          <i class="fa fa-clone" aria-hidden="true"></i>
        </button>
      </div>
      <i class="icon-small-close" (click)="notificationService.remove(toast)"></i>
    </div>
  </ngb-toast>
</div>